import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, of, switchMap, tap} from 'rxjs';
import {OrderDetailsActions} from './order-details.actions';
import {OrderApiService} from 'app/data/order-api.service';
import {OrderDetailsNavigationService} from 'app/order-details/order-details-navigation.service';
import {ErrorActions} from 'app/core/components/error-page/state/error.actions';

@Injectable()
export class OrderDetailsEffects {
  loadOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderDetailsActions.loadOrder),
      switchMap(props =>
        this.service.get(props.saleNumber).pipe(
          map(response =>
            OrderDetailsActions.loadOrderSuccess({
              order: response.result,
            })
          ),
          catchError(error => of(OrderDetailsActions.loadOrderFailure({error})))
        )
      )
    )
  );

  loadOrderFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderDetailsActions.loadOrderFailure),
        map(({error}) => ErrorActions.directToErrorPage({error}))
      ),
    {dispatch: false}
  );

  navigateBack$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderDetailsActions.navigateBack),
        tap(() => this.navigationService.back())
      ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private service: OrderApiService,
    private navigationService: OrderDetailsNavigationService
  ) {}
}
